"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty2 = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-property"));

var _defineProperties = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-properties"));

var _getOwnPropertyDescriptors = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors"));

var _getOwnPropertyDescriptor = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor"));

var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _assign = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/assign"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _get2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/get"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _defineProperty3 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _cssConstants = _interopRequireDefault(require("../../../../targets/cord_sanofi/cssConstants.js"));

var _config = _interopRequireDefault(require("../../../../targets/cord_sanofi/config.js"));

var _ErvFront = _interopRequireDefault(require("./ErvFront.scss"));

var _KESI2BasicComponent = _interopRequireDefault(require("../../../KESI2/KESI2BasicComponent"));

var _CordovaFileHelper = _interopRequireDefault(require("../../../helpers/CordovaFileHelper"));

var _DeviceInfoHelper = _interopRequireDefault(require("../../../helpers/DeviceInfoHelper"));

var _DrupalLecture = _interopRequireDefault(require("./DrupalLecture"));

var _Image = _interopRequireDefault(require("../Image/Image"));

var _ColorHelper = require("../../../helpers/ColorHelper");

var _KeyboardHelper = require("../../../helpers/KeyboardHelper");

var _DataStore = _interopRequireWildcard(require("../../../KESI2/Stores/DataStore2"));

var _Constants = require("../../constants/Constants");

var _KESI2Helper = _interopRequireDefault(require("../../../KESI2/KESI2Helper"));

var _reactFontawesome = _interopRequireDefault(require("react-fontawesome"));

var _DrupalNestedNonFlippingTiles = _interopRequireDefault(require("./DrupalNestedNonFlippingTiles"));

var _NavigationManagerCordova = _interopRequireDefault(require("../../NavigationManagerCordova"));

var _AppUtils = require("../../../utils/AppUtils");

var _ZoomOutMap = _interopRequireDefault(require("@material-ui/icons/ZoomOutMap"));

var _PreconditionChecker = require("../../../utils/PreconditionChecker");

var _JSONHelper = require("../../../helpers/JSONHelper");

function ownKeys(object, enumerableOnly) { var keys = (0, _keys["default"])(object); if (_getOwnPropertySymbols["default"]) { var symbols = (0, _getOwnPropertySymbols["default"])(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return (0, _getOwnPropertyDescriptor["default"])(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty3["default"])(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors["default"]) { (0, _defineProperties["default"])(target, (0, _getOwnPropertyDescriptors["default"])(source)); } else { ownKeys(Object(source)).forEach(function (key) { (0, _defineProperty2["default"])(target, key, (0, _getOwnPropertyDescriptor["default"])(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var FRONT_ID = 'front_';
var SUBTYPE_CORPORATE = 'corporateLecture';

var ErvFront = /*#__PURE__*/function (_Kesi2BasicComponent) {
  (0, _inherits2["default"])(ErvFront, _Kesi2BasicComponent);

  var _super = _createSuper(ErvFront);

  function ErvFront(props, context) {
    var _thisSuper, _this;

    (0, _classCallCheck2["default"])(this, ErvFront);
    _this = _super.call(this, props, context, props.id);
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "getBackgroundColor", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
      var frontEl, color;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (_this.props.backgroundColor) {
                if (_this.props.greyedOut || _this.props.regionUnavailable) {
                  _this.setState({
                    lightColor: (0, _ColorHelper.isLightColor)('#e1e1e1')
                  });
                } else {
                  _this.setState({
                    lightColor: (0, _ColorHelper.isLightColor)(_this.props.backgroundColor)
                  });
                }
              } else {
                frontEl = document.getElementById("".concat(FRONT_ID).concat(_this.props.id));

                if (frontEl) {
                  color = window.getComputedStyle(frontEl).backgroundColor;

                  _this.setState({
                    lightColor: (0, _ColorHelper.isLightColorRGB)(color)
                  });
                }
              }

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "closeTile", function () {
      console.log('ERV Front close tile');

      if (_this.state.data[_DataStore.DATA_STORE_PATHS.TC_ASK_FOR_APP_TURNED_ON] && _this.state.data[_DataStore.DATA_STORE_PATHS.TC_ASK_FOR_APP_RATING_ON_NEXT_TILE_CLOSING]) {
        setTimeout(function () {
          // don't wait
          (0, _AppUtils.askUserForAppRating)(_DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.TC_ASK_FOR_APP_RATING_OPTIONS)); // disable setting for the next time

          var data = {};
          data[_DataStore.DATA_STORE_PATHS.TC_ASK_FOR_APP_TURNED_ON] = false;
          data[_DataStore.DATA_STORE_PATHS.TC_ASK_FOR_APP_RATING_AFTER_NEXT_PUSH_OPENED] = false;
          data[_DataStore.DATA_STORE_PATHS.TC_ASK_FOR_APP_RATING_ON_NEXT_TILE_CLOSING] = false;

          _DataStore["default"].setData(data);
        }, 500);
      }

      _this.props.closeTile(_this.props.domId);
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "getLectureColor", function () {
      var lectureColor;

      if (_config["default"].isSafetureApp) {
        if (_this.props.greyedOut || _this.props.regionUnavailable) {
          lectureColor = '#e1e1e1';
        } else {
          lectureColor = _this.props.backgroundColor;
        }
      } else {
        if (_config["default"].useKeywordAsColor) {
          lectureColor = _this.props.keywords;
        } else if (_cssConstants["default"].colors.titleBackgroundOverlay) {
          lectureColor = _cssConstants["default"].colors.titleBackgroundOverlay;
        } else if (_this.props.backgroundColor) {
          lectureColor = _this.props.backgroundColor;
        }
      }

      return lectureColor;
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "getLangCode", function () {
      var browserLanguage = navigator.languages && navigator.languages[0] || navigator.language;
      var languageWithoutRegionCode = browserLanguage.toLowerCase().split(/[_-]+/);
      var browserLanguageCode;

      if (languageWithoutRegionCode.length > 1) {
        browserLanguageCode = languageWithoutRegionCode[0].toLowerCase();
      }

      var storedLanguage = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.TC_LANGUAGE);

      var currentLanguageCode = storedLanguage ? storedLanguage.languageCode : browserLanguageCode;
      return currentLanguageCode;
    });
    _this.state = _objectSpread({
      filePath: _DeviceInfoHelper["default"].isBrowser() ? null : _CordovaFileHelper["default"].getDataFolder(),
      lightColor: null,
      isOpen: false
    }, _this.state);
    (0, _get2["default"])((_thisSuper = (0, _assertThisInitialized2["default"])(_this), (0, _getPrototypeOf2["default"])(ErvFront.prototype)), "setDataStorePaths", _thisSuper).call(_thisSuper, [_DataStore.DATA_STORE_PATHS.TC_USER_ROLE, _DataStore.DATA_STORE_PATHS.TC_CORPORATE_CARD_ICON, _DataStore.DATA_STORE_PATHS.TC_ASK_FOR_APP_TURNED_ON, _DataStore.DATA_STORE_PATHS.TC_ASK_FOR_APP_RATING_ON_NEXT_TILE_CLOSING, _DataStore.DATA_STORE_PATHS.KESI_ADDITIONAL_DATA]);
    _this.isOpen = false;
    _this.isInternetExplorer = _DeviceInfoHelper["default"].isInternetExplorer();
    return _this;
  }
  /*
  componentWillUpdate (nextProps, nextState) {
    const langCode = this.getLangCode()
     if (!this.props.expanded && nextProps.expanded && nextProps.title) {
      if (target.tcCountryHelper) {
        const regionCode = nextProps.regionCode || (nextProps.currentRegionCache && nextProps.currentRegionCache.basicInformation && nextProps.currentRegionCache.basicInformation.isoString ? nextProps.currentRegionCache.basicInformation.isoString : null)
        nextProps.setTitle(nextProps.title.replace('{country}', target.tcCountryHelper.getCountryByCode(regionCode, langCode) || ''))
      }
      this.props.setBackButtonFunc(() => this.closeTile())
      console.log(this.props.isOnFirstLayer ? `setting outer back func for id ${this.props.domId}` : `setting inner back func for id ${this.props.domId}`)
    }
     if (this.props.expanded && !nextProps.expanded) {
      console.log('closing tile', nextProps)
      if (nextProps.isOnFirstLayer) {
        nextProps.setBackButtonFunc(null)
      }
      else {
        console.log('not setting back button func because we are not on first layer', nextProps)
        nextProps.setBackButtonFunc(() => nextProps.outerCloseTile(nextProps.outerDomId))
      }
    }
  }
  */


  (0, _createClass2["default"])(ErvFront, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.getBackgroundColor();

      var usedJump = _NavigationManagerCordova["default"].getUsedJump();

      if (usedJump) {
        this.props.setBackButtonFunc(function () {
          return _NavigationManagerCordova["default"].jumpBack();
        });
      }

      var storePaths = [];

      var content = _KESI2Helper["default"].getContentById(this.props.id);

      storePaths.push("".concat(_DataStore.DATA_STORE_PATHS.KESI_ADDITIONAL_DATA, ".").concat(this.props.id));

      if (content && content.lectureIds && content.lectureIds.length > 0) {
        content.lectureIds.forEach(function (id) {
          storePaths.push("".concat(_DataStore.DATA_STORE_PATHS.KESI_ADDITIONAL_DATA, ".").concat(id, " "));
        });
      }

      if (content && content.spocIds && content.spocIds.length > 0) {
        content.spocIds.forEach(function (id) {
          storePaths.push("".concat(_DataStore.DATA_STORE_PATHS.KESI_ADDITIONAL_DATA, ".").concat(id));
        });
      }

      if (content && content.nuggetIds && content.nuggetIds.length > 0) {
        content.nuggetIds.forEach(function (id) {
          storePaths.push("".concat(_DataStore.DATA_STORE_PATHS.KESI_ADDITIONAL_DATA, ".").concat(id));
        });
      }

      (0, _get2["default"])((0, _getPrototypeOf2["default"])(ErvFront.prototype), "setDataStorePaths", this).call(this, storePaths);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      var _this2 = this;

      (0, _get2["default"])((0, _getPrototypeOf2["default"])(ErvFront.prototype), "componentDidUpdate", this).call(this, prevProps, prevState, snapshot);
      var langCode = this.getLangCode();

      var usedJump = _NavigationManagerCordova["default"].getUsedJump();

      if (!prevProps.expanded && this.props.expanded && this.props.title) {
        console.log('tile was opened', this.props.wasOpenedAutomatically);

        if (_config["default"].tcCountryHelper) {
          var regionCode = this.props.regionCode || (this.props.currentRegionCache && this.props.currentRegionCache.basicInformation && this.props.currentRegionCache.basicInformation.isoString ? this.props.currentRegionCache.basicInformation.isoString : null);
          this.props.setTitle(this.props.title.replace('{country}', _config["default"].tcCountryHelper.getCountryByCode(regionCode, langCode) || ''));
        }

        if (this.props.wasOpenedAutomatically) {
          this.props.setBackButtonFunc(function () {
            return _NavigationManagerCordova["default"].jumpBack();
          });
        } else {
          this.props.setBackButtonFunc(function () {
            return _this2.closeTile();
          });
        }
      }

      if (prevProps.expanded && !this.props.expanded) {
        console.log('tile was closed', this.props.id, this.props.isOnFirstLayer);

        if (this.props.isOnFirstLayer) {
          if (usedJump) {
            this.props.setBackButtonFunc(function () {
              return _NavigationManagerCordova["default"].jumpBack();
            });
          } else {
            this.props.setBackButtonFunc(null);
          }
        } else {
          console.log('settingBackButtonFunc in ERV FRONT nach schließen', prevProps.contentPathArray, this.props.contentPathArray);

          if (usedJump) {
            this.props.setBackButtonFunc(function () {
              return _NavigationManagerCordova["default"].jumpBack();
            });
          } else {
            this.props.setBackButtonFunc(function () {
              return _this2.props.outerCloseTile(_this2.props.outerDomId);
            });
          }
        }
      }

      if (prevProps.regionUnavailable && !this.props.regionUnavailable) {
        console.log('region now available');
        this.getBackgroundColor();
      }

      if (prevProps.backgroundColor !== this.props.backgroundColor) {
        this.getBackgroundColor();
      } // TODO: Update colors when userRole is changing


      if (prevState.data[_DataStore.DATA_STORE_PATHS.TC_USER_ROLE] && prevState.data[_DataStore.DATA_STORE_PATHS.TC_USER_ROLE] !== this.state[_DataStore.DATA_STORE_PATHS.TC_USER_ROLE]) {
        this.getBackgroundColor();
      }

      if (this.props.willBeOpened && !this.isOpen) {
        this.props.tileContentDidMount();
        this.isOpen = true;
      }

      if (this.isOpen && !(this.props.willBeOpened || this.props.animated || this.props.expanded)) {
        this.isOpen = false;
        (0, _KeyboardHelper.hideKeyboard)(true);
        (0, _KeyboardHelper.setSoftKeyboardShrinksPage)(true);
      }
    }
  }, {
    key: "getClassNames",
    value: function getClassNames() {
      var classNames = "".concat(_ErvFront["default"].front);
      var isNewDesign = _config["default"].isNewDesign;

      if (!isNewDesign && !this.hasBackgroundImage() && !this.props.backgroundColor) {
        classNames += " ".concat(this.props.colorClasses ? this.props.colorClasses.backgroundClass : null);
      }

      if (this.props.glows) {
        classNames += " ".concat(this.props.colorClasses.glowClass);
      }

      if (this.props.expanded) {
        classNames += " ".concat(_ErvFront["default"].expandedFront);
      }

      return classNames;
    }
  }, {
    key: "getStyle",
    value: function getStyle() {
      var lightColor = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var titleSize = _cssConstants["default"].tiles.titleSize;
      var titleSizeVW = _cssConstants["default"].tiles.titleSizeVW;
      var subtitleSize = _cssConstants["default"].tiles.subtitleHeight ? _cssConstants["default"].tiles.subtitleHeight : _cssConstants["default"].tiles.titleSize - 3;
      var subtitleBottom = _cssConstants["default"].tiles.subtitleBottom ? _cssConstants["default"].tiles.subtitleBottom : 0;
      var titleTop = _cssConstants["default"].tiles.titleTop ? _cssConstants["default"].tiles.titleTop : 2 * 10 + _cssConstants["default"].tiles.iconSize;
      var titleLineHeight = _cssConstants["default"].tiles.titleLineHeight ? _cssConstants["default"].tiles.titleLineHeight : _cssConstants["default"].tiles.titleSize + 7;
      var subtitleLineHeight = _cssConstants["default"].tiles.subtitleLineHeight ? _cssConstants["default"].tiles.subtitleLineHeight : _cssConstants["default"].tiles.titleSize - 3 - 2 + 6;
      var iconSize = _cssConstants["default"].tiles.iconSize;
      var padding = 10;

      if (!_config["default"].useZoomForTileFront && window.innerWidth < _Constants.SMALL_TEXT_DEVICE_WIDTH) {
        // L tile
        titleSize = _cssConstants["default"].tiles.titleSize - 4;
        subtitleSize = _cssConstants["default"].tiles.titleSize - 7;
        titleTop = 2 * 7 + _cssConstants["default"].tiles.iconSize;
        titleLineHeight = _cssConstants["default"].tiles.titleSize - 4 + 5;
        subtitleLineHeight = _cssConstants["default"].tiles.titleSize - 7 + 5;
        iconSize = _cssConstants["default"].tiles.iconSize;
        padding = 7;
      }

      var titleColor = null;
      var subtitleColor = null;
      var isNewDesign = _config["default"].isNewDesign;

      if ((this.props.greyedOut || this.props.regionUnavailable) && !_config["default"].useOpacityInsteadOfGreyedOut) {
        titleColor = '#9b9b9b';
        subtitleColor = '#9b9b9b';
      } else if (isNewDesign) {
        titleColor = _cssConstants["default"].colors.ervText;
        subtitleColor = _cssConstants["default"].colors.ervSubtitle;
      } else if (!isNewDesign && (_config["default"].forceTitleColor || lightColor) && _cssConstants["default"].colors.ervText) {
        titleColor = _cssConstants["default"].colors.ervText;
        subtitleColor = _cssConstants["default"].colors.ervText;
      } else {
        if (this.props.fontColor) {
          titleColor = this.props.fontColor;
          subtitleColor = this.props.fontColor;
        } else {
          titleColor = _cssConstants["default"].colors.tileTitleColor ? _cssConstants["default"].colors.tileTitleColor : _cssConstants["default"].colors.tileStandardTextColor;
          subtitleColor = _cssConstants["default"].colors.tileSubtitleColor ? _cssConstants["default"].colors.tileSubtitleColor : _cssConstants["default"].colors.tileStandardTextColor;
        }
      }

      if (_config["default"].useZoomForTileFront && !_DeviceInfoHelper["default"].isBrowser()) {
        titleSize = titleSize * this.props.zoomValue;
        subtitleSize = subtitleSize * this.props.zoomValue;
        titleTop = typeof titleTop === 'string' && titleTop.indexOf('%') !== -1 ? titleTop : titleTop * this.props.zoomValue;
        titleLineHeight = titleLineHeight * this.props.zoomValue;
        subtitleLineHeight = subtitleLineHeight * this.props.zoomValue;
        iconSize = iconSize * this.props.zoomValue;
        padding = padding * this.props.zoomValue;
        subtitleBottom = typeof subtitleBottom === 'string' && subtitleBottom.indexOf('%') !== -1 ? subtitleBottom : subtitleBottom * this.props.zoomValue;
      }

      var arrowColor = this.props.arrowColor ? this.props.arrowColor : _cssConstants["default"].colors.navbarBackground;
      var lectureColor = this.getLectureColor();

      if (this.props.isShrinked) {
        titleSize = titleSize * 0.7;
        subtitleSize = subtitleSize * 0.7;
        titleTop = typeof titleTop === 'string' && titleTop.indexOf('%') !== -1 ? titleTop : titleTop * 0.7;
        titleLineHeight = titleLineHeight * 0.7;
        subtitleLineHeight = subtitleLineHeight * 0.7;
        iconSize = iconSize * 0.7;
        padding = padding * 0.7;
        subtitleBottom = typeof subtitleBottom === 'string' && subtitleBottom.indexOf('%') !== -1 ? subtitleBottom : subtitleBottom * 0.7;
      }

      var style = {
        title: {
          fontSize: titleSizeVW || titleSize,
          padding: "0 ".concat(padding, "px"),
          paddingLeft: _config["default"].showTitleAtBottom ? 5 : padding,
          paddingRight: _config["default"].showArrowOnTile ? _config["default"].useZoomForTileFront ? padding + _cssConstants["default"].tiles.backgroundHeight * this.props.zoomValue : padding + _cssConstants["default"].tiles.backgroundHeight : padding,
          lineHeight: "".concat(titleLineHeight * 0.8, "px"),
          maxHeight: "".concat(3 * titleLineHeight, "px"),
          zIndex: this.props.expanded ? -1 : 6,
          left: 0,
          // top: `${(this.props.correctedSize / 2) - titleLineHeight}px`,
          top: _config["default"].showTitleAtBottom ? null : typeof subtitleBottom === 'string' && subtitleBottom.indexOf('%') !== -1 ? titleTop : "".concat(titleTop, "px"),
          bottom: _config["default"].showTitleAtBottom ? '5px' : null,
          color: titleColor,
          opacity: this.props.animated ? 0 : 1,
          transform: 'translate3d(0, 0, 0)',
          transition: _DeviceInfoHelper["default"].isAndroid() ? '' : 'color 400ms',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          fontWeight: _cssConstants["default"].tiles.titleFontWeight ? _cssConstants["default"].tiles.titleFontWeight : 'normal'
        },
        subtitle: {
          fontSize: subtitleSize,
          lineHeight: "".concat(subtitleLineHeight, "px"),
          maxHeight: "".concat(3 * subtitleLineHeight + 2 * padding + 30, "px"),
          height: '100%',
          zIndex: this.props.expanded ? -1 : 6,
          padding: padding,
          transform: 'translate3d(0, 0, 0)',
          color: subtitleColor,
          opacity: this.props.isShrinked || this.props.animated ? 0 : 1,
          willChange: 'opacity, color',
          transition: _DeviceInfoHelper["default"].isAndroid() ? '' : 'color 400ms, opacity 500ms',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          bottom: typeof subtitleBottom === 'string' && subtitleBottom.indexOf('%') !== -1 ? subtitleBottom : "".concat(subtitleBottom - 20, "px")
        },
        titleBackground: {
          width: '100%',
          minHeight: typeof _cssConstants["default"].tiles.backgroundHeight === 'string' && _cssConstants["default"].tiles.backgroundHeight.indexOf('%') !== -1 ? _config["default"].useZoomForTileFront || this.isInternetExplorer ? this.props.zoomValue * _cssConstants["default"].tiles.backgroundHeight : _cssConstants["default"].tiles.backgroundHeight : "".concat(_config["default"].useZoomForTileFront || this.isInternetExplorer ? this.props.zoomValue * _cssConstants["default"].tiles.backgroundHeight : _cssConstants["default"].tiles.backgroundHeight, "px"),
          overflow: 'hidden',
          zIndex: 5
        },
        titleBackgroundBlur: {
          filter: this.props.background ? _cssConstants["default"].tiles.blur : 'blur(0)',
          backgroundImage: this.hasBackgroundImage() ? _DeviceInfoHelper["default"].isBrowser() ? "url(".concat(this.props.background, ")") : "url(".concat(this.state.filePath).concat(this.props.background, ")") : 'none',
          zIndex: 6,
          backgroundSize: '100% 100%',
          height: this.props.correctedSize + 'px',
          width: '100%',
          transform: 'translate3d(0, 0, 0)',
          backgroundColor: _cssConstants["default"].tiles.backgroundColor,
          margin: _cssConstants["default"].tiles.margin
        },
        titleBackgroundOverlay: {
          backgroundColor: _DeviceInfoHelper["default"].isInternetExplorer() && this.props.isGrayScale ? '#a6a6a6' : _config["default"].useKeywordAsColor ? this.props.keywords : _cssConstants["default"].colors.titleBackgroundOverlay,
          opacity: _cssConstants["default"].tiles.backgroundOverlayOpacity ? _cssConstants["default"].tiles.backgroundOverlayOpacity : null,
          zIndex: 5,
          height: '100%',
          width: '100%',
          transform: 'translate3d(0, 0, 0)',
          borderRadius: _cssConstants["default"].tiles.overlayBorderRadius ? _cssConstants["default"].tiles.overlayBorderRadius : 0
        },
        icon: {
          height: 'auto',
          maxHeight: '100%',
          zIndex: this.props.expanded ? -1 : 6,
          margin: _cssConstants["default"].tiles.iconMargin ? "".concat(_cssConstants["default"].tiles.iconMargin, "px") : '0 auto',
          display: 'block',
          opacity: this.props.animated || this.props.expanded ? 0 : 1,
          transition: _DeviceInfoHelper["default"].isAndroid() ? '' : 'fill 400ms'
        },
        iconContainer: {
          height: iconSize,
          zIndex: this.props.expanded ? -1 : 6,
          width: '100%',
          maxWidth: _cssConstants["default"].tiles.iconSize ? _cssConstants["default"].tiles.iconSize : '50px'
        },
        background: {
          width: '100%',
          height: '100%',
          zIndex: this.props.expanded ? -1 : 3
        },
        front: {
          overflow: 'hidden',
          backgroundColor: _config["default"].useBackgroundColorNotForWholeTile ? null : lectureColor,
          border: _config["default"].useBackgroundColorNotForWholeTile ? "2px solid ".concat(lectureColor ? lectureColor : _cssConstants["default"].tiles.backgroundColor) : null,
          borderRadius: _cssConstants["default"].tiles.borderRadius ? _cssConstants["default"].tiles.borderRadius : 0,
          maxHeight: this.props.expanded ? 0 : "".concat(this.props.correctedSize, "px"),
          opacity: this.props.animated || this.props.expanded ? 0 : 1,
          transition: _DeviceInfoHelper["default"].isAndroid() ? 'opacity 250ms' : 'opacity 500ms'
        },
        arrow: {
          backgroundColor: arrowColor,
          height: _config["default"].useZoomForTileFront ? "".concat(_cssConstants["default"].tiles.backgroundHeight * this.props.zoomValue, "px") : "".concat(_cssConstants["default"].tiles.backgroundHeight, "px"),
          width: _config["default"].useZoomForTileFront ? "".concat(_cssConstants["default"].tiles.backgroundHeight * this.props.zoomValue, "px") : "".concat(_cssConstants["default"].tiles.backgroundHeight, "px"),
          lineHeight: _config["default"].useZoomForTileFront ? "".concat(_cssConstants["default"].tiles.backgroundHeight * this.props.zoomValue, "px") : "".concat(_cssConstants["default"].tiles.backgroundHeight, "px")
        },
        innerArrow: {
          height: _config["default"].useZoomForTileFront ? (_cssConstants["default"].tiles.backgroundHeight - 15) * this.props.zoomValue : _cssConstants["default"].tiles.backgroundHeight - 15,
          width: _config["default"].useZoomForTileFront ? (_cssConstants["default"].tiles.backgroundHeight - 15) * this.props.zoomValue : _cssConstants["default"].tiles.backgroundHeight - 15
        },
        containerLeft: {},
        containerRight: {},
        dayInfo: {
          position: 'absolute',
          top: '20px',
          left: '20px',
          zIndex: 10,
          fontWeight: 'bold'
        },
        progressBar: {
          height: '28px',
          borderRadius: '14px',
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          zIndex: 20,
          overflow: 'hidden'
        },
        progressBarInner: {
          height: '28px',
          transform: 'skewX(20deg)',
          zIndex: 1,
          left: '-10px',
          top: 0,
          position: 'absolute'
        }
      };

      if (_cssConstants["default"].tiles.titleStyle) {
        style.title = (0, _assign["default"])(style.title, _cssConstants["default"].tiles.titleStyle);
      }

      if (_cssConstants["default"].tiles.subtitleStyle) {
        style.subtitle = (0, _assign["default"])(style.subtitle, _cssConstants["default"].tiles.subtitleStyle);
      }

      if (_cssConstants["default"].tiles.iconStyle) {
        style.icon = (0, _assign["default"])(style.icon, _cssConstants["default"].tiles.iconStyle);
      }

      if (_cssConstants["default"].tiles.titleBackgroundStyle) {
        style.titleBackground = (0, _assign["default"])(style.titleBackground, _cssConstants["default"].tiles.titleBackgroundStyle);
      }

      if (_cssConstants["default"].tiles.titleBackgroundBlurStyle) {
        style.titleBackgroundBlur = (0, _assign["default"])(style.titleBackgroundBlur, _cssConstants["default"].tiles.titleBackgroundBlurStyle);
      }

      if (_cssConstants["default"].tiles.titleBackgroundOverlayStyle) {
        style.titleBackgroundOverlay = (0, _assign["default"])(style.titleBackgroundOverlay, _cssConstants["default"].tiles.titleBackgroundOverlayStyle);
      }

      if (_cssConstants["default"].tiles.iconContainerStyle) {
        style.iconContainer = (0, _assign["default"])(style.iconContainer, _cssConstants["default"].tiles.iconContainerStyle);
      }

      if (_cssConstants["default"].tiles.backgroundStyle) {
        style.background = (0, _assign["default"])(style.background, _cssConstants["default"].tiles.backgroundStyle);
      }

      if (_cssConstants["default"].tiles.frontStyle) {
        style.front = (0, _assign["default"])(style.front, _cssConstants["default"].tiles.frontStyle);
      }

      if (_cssConstants["default"].tiles.arrowStyle) {
        style.arrow = (0, _assign["default"])(style.arrow, _cssConstants["default"].tiles.arrowStyle);
      }

      if (_cssConstants["default"].tiles.innerArrowStyle) {
        style.innerArrow = (0, _assign["default"])(style.innerArrow, _cssConstants["default"].tiles.innerArrowStyle);
      }

      if (_cssConstants["default"].tiles.containerLeftStyle) {
        style.containerLeft = (0, _assign["default"])(style.containerLeft, _cssConstants["default"].tiles.containerLeftStyle);
      }

      if (_cssConstants["default"].tiles.containerRightStyle) {
        style.containerRight = (0, _assign["default"])(style.containerRight, _cssConstants["default"].tiles.containerRightStyle);
      }

      if (_cssConstants["default"].tiles.dayInfoStyle) {
        style.dayInfo = (0, _assign["default"])(style.dayInfo, _cssConstants["default"].tiles.dayInfoStyle);
      }

      if (_cssConstants["default"].tiles.progressBarStyle) {
        style.progressBar = (0, _assign["default"])(style.progressBar, _cssConstants["default"].tiles.progressBarStyle);
      }

      if (_cssConstants["default"].tiles.progressBarInnerStyle) {
        style.progressBarInner = (0, _assign["default"])(style.progressBarInner, _cssConstants["default"].tiles.progressBarInnerStyle);
      }

      return style;
    }
  }, {
    key: "hasBackgroundImage",
    value: function hasBackgroundImage() {
      if (_DeviceInfoHelper["default"].isBrowser()) {
        return this.props.background;
      }

      return this.state.filePath && this.props.background;
    }
  }, {
    key: "hasIcon",
    value: function hasIcon() {
      if (_DeviceInfoHelper["default"].isBrowser()) {
        return this.props.icon || this.props.svgIcon || this.props.newSvgIcon;
      }

      return this.state.filePath && (this.props.icon || this.props.svgIcon || this.props.newSvgIcon);
    }
  }, {
    key: "renderIcon",
    value: function renderIcon(style) {
      var _this$props$keywords;

      var className;
      var isAirDoctor = this.props.keywords && ((_this$props$keywords = this.props.keywords) === null || _this$props$keywords === void 0 ? void 0 : _this$props$keywords.indexOf('airdoctor')) !== -1 || false;
      var isNewDesign = _config["default"].isNewDesign;

      if (this.props.greyedOut || this.props.regionUnavailable) {
        className = _ErvFront["default"].iconDisabled;
      } else {
        if (isNewDesign) {
          if (isAirDoctor) className = _ErvFront["default"].iconNewNoFill;else className = _ErvFront["default"].iconNew;
        } else {
          if (this.state.lightColor) {
            className = _ErvFront["default"].icon;
          } else {
            className = _ErvFront["default"].iconWhite;
          }
        }
      }

      className += ' doNotInvert';

      if (_config["default"].isNewDesign && this.props.newSvgIcon) {
        var _path = _DeviceInfoHelper["default"].isBrowser() ? this.props.newSvgIcon : "".concat(this.state.filePath).concat(this.props.newSvgIcon);

        if (this.hasIcon()) {
          return /*#__PURE__*/_react["default"].createElement("div", {
            style: style.iconContainer,
            className: _ErvFront["default"].iconContainer
          }, /*#__PURE__*/_react["default"].createElement(_Image["default"], {
            src: _path,
            style: style.icon,
            alt: this.props.enhancedIcon && this.props.enhancedIcon.alt ? this.props.enhancedIcon.alt : 'Themenicon',
            className: "".concat(className, " doNotInvert")
          }));
        }

        return null;
      }

      if (this.props.svgIcon) {
        var _path2 = _DeviceInfoHelper["default"].isBrowser() ? this.props.svgIcon : "".concat(this.state.filePath).concat(this.props.svgIcon);

        if (this.hasIcon()) {
          return /*#__PURE__*/_react["default"].createElement("div", {
            style: style.iconContainer,
            className: _ErvFront["default"].iconContainer
          }, /*#__PURE__*/_react["default"].createElement(_Image["default"], {
            src: _path2,
            style: style.icon,
            alt: 'Themenicon',
            className: className
          }));
        }

        return null;
      }

      var isCorporateCardAndHasIcon = this.props.subtype === SUBTYPE_CORPORATE && this.state.data[_DataStore.DATA_STORE_PATHS.TC_CORPORATE_CARD_ICON];
      var path = isCorporateCardAndHasIcon ? this.state.data[_DataStore.DATA_STORE_PATHS.TC_CORPORATE_CARD_ICON] : null;

      if (!path) {
        path = _DeviceInfoHelper["default"].isBrowser() ? this.props.icon : "".concat(this.state.filePath).concat(this.props.icon);
      }

      if (isCorporateCardAndHasIcon || this.hasIcon()) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          style: style.iconContainer,
          className: _ErvFront["default"].iconContainer
        }, /*#__PURE__*/_react["default"].createElement(_Image["default"], {
          src: path,
          style: style.icon,
          className: "".concat(_ErvFront["default"].icon, " ").concat(className)
        }));
      }

      return null;
    }
  }, {
    key: "renderBackground",
    value: function renderBackground(style) {
      var content = this.state.content[this.props.id];
      var path = _DeviceInfoHelper["default"].isBrowser() ? this.props.background : "".concat(this.state.filePath).concat(this.props.background);
      var img;

      var statementImg = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.ERGOPRO_STATEMENT_PIC);

      if (this.props.keywords === 'statement' && statementImg) {
        img = /*#__PURE__*/_react["default"].createElement(_Image["default"], {
          alt: "statement image",
          src: statementImg,
          style: style === null || style === void 0 ? void 0 : style.background,
          className: "".concat(_ErvFront["default"].background, " tileBackground")
        });
      } else {
        img = this.hasBackgroundImage() ? /*#__PURE__*/_react["default"].createElement(_Image["default"], {
          alt: this.props.enhancedIcon ? this.props.enhancedIcon.alt : '',
          src: path,
          style: style === null || style === void 0 ? void 0 : style.background,
          className: "".concat(_ErvFront["default"].background, " tileBackground")
        }) : content.backgroundColor && !_config["default"].useBackgroundColorNotForWholeTile && !_config["default"].isSafetureApp ? /*#__PURE__*/_react["default"].createElement("div", {
          style: (0, _assign["default"])((style === null || style === void 0 ? void 0 : style.background) || {}, {
            backgroundColor: this.props.backgroundColor
          }),
          className: _ErvFront["default"].background
        }) : null;
      }

      return /*#__PURE__*/_react["default"].createElement("div", {
        className: 'tileBackgroundContainer'
      }, img, this.props.enhancedBackground && this.props.enhancedBackground.copyright ? /*#__PURE__*/_react["default"].createElement("div", {
        className: _ErvFront["default"].background,
        style: style === null || style === void 0 ? void 0 : style.background
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "".concat(_ErvFront["default"].backgroundCopyright, " copyright")
      }, this.props.enhancedBackground.copyright)) : null, !(_config["default"].useBackgroundImageTitle && img) && /*#__PURE__*/_react["default"].createElement("div", {
        className: _ErvFront["default"].titleBackground,
        style: style === null || style === void 0 ? void 0 : style.titleBackground
      }, _cssConstants["default"].tiles.blurPx > 0 ? /*#__PURE__*/_react["default"].createElement("div", {
        className: _ErvFront["default"].titleBackgroundBlur,
        style: style === null || style === void 0 ? void 0 : style.titleBackgroundBlur
      }) : null, /*#__PURE__*/_react["default"].createElement("div", {
        className: _ErvFront["default"].titleBackgroundOverlay,
        style: (0, _assign["default"])((style === null || style === void 0 ? void 0 : style.titleBackgroundOverlay) || {}, {
          backgroundColor: _config["default"].isSafetureApp ? null : this.props.backgroundColor
        })
      })));
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this,
          _style$innerArrow,
          _style$innerArrow2,
          _style$innerArrow3,
          _style$innerArrow4;

      var style = this.getStyle(this.state.lightColor);
      var currentLanguageCode = this.getLangCode();
      var title = this.props.title ? this.props.title.replace('{country}', this.props.regionCode && _config["default"].tcCountryHelper ? _config["default"].tcCountryHelper.getCountryByCode(this.props.regionCode, currentLanguageCode) : '' || '') : '';
      var subtitle = this.props.subtitle || '';
      var fav = false;
      var read = false;
      var percentage = 0;

      var additionalData = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.KESI_ADDITIONAL_DATA);

      fav = additionalData && additionalData[this.props.id] ? additionalData[this.props.id].favorite : false;

      if (_config["default"].setReadToStore) {
        if (additionalData && additionalData[this.props.id]) {
          if (_config["default"].markOpenedLecturesAsCompletelyRead) {
            read = additionalData[this.props.id].read || false;
          } else {
            percentage = _KESI2Helper["default"].getPercentageForContent(this.props.id);
            read = percentage >= 100; // || notMandatory
          }
        }
      }

      var content = this.state.content[this.props.id];
      var renderAnotherLayer = content && content.lectureIds || false;
      var useOnlyAsLink = this.props.useAsLink;
      var extraClassName = this.props.isPublished ? '' : " ".concat(_ErvFront["default"].unpublished);
      var containerRightStyle = {
        color: 'white',
        top: '10px',
        right: '10px',
        fontSize: '20px'
      };

      if (_DeviceInfoHelper["default"].isInternetExplorer()) {
        containerRightStyle = {
          top: "".concat(10 * this.props.zoomValue, "px"),
          right: "".concat(10 * this.props.zoomValue, "px"),
          fontSize: "".concat(20 * this.props.zoomValue, "px")
        };
      }

      if (_config["default"].showRightContainerAtTheBottom) {
        containerRightStyle = {
          bottom: '3px',
          right: '3px',
          fontSize: '15px'
        };
      }

      containerRightStyle = (0, _assign["default"])(containerRightStyle, style.containerRight);
      var currentDayStr;

      if (_config["default"].showDayInfoOnTile) {
        if (this.props.currentDay === 0) {
          currentDayStr = 'START';
        } else if (this.props.currentDay === 7) {
          currentDayStr = "TAG ".concat(this.props.currentDay, " | WOCHENR\xDCCKBLICK");
        } else if (this.props.currentDay) {
          currentDayStr = "TAG ".concat(this.props.currentDay);
        }
      }

      var percentageInfo = null;

      if (_config["default"].renderProgressBarOnTile) {
        var _content = _KESI2Helper["default"].getContentById(this.props.id);

        var failingPrecondition;

        if (_content && _content.openPrecondition) {
          failingPrecondition = (0, _PreconditionChecker.getFailingPrecondition)(_content.openPrecondition);
        }

        if (percentage >= 99) {
          percentageInfo = /*#__PURE__*/_react["default"].createElement("p", null, "Abgeschlossen");
        } else if (percentage > 0) {
          percentageInfo = /*#__PURE__*/_react["default"].createElement("p", null, "Fortschritt");
        } else {
          percentageInfo = /*#__PURE__*/_react["default"].createElement("p", {
            style: {
              color: 'black'
            }
          }, failingPrecondition ? 'Login notwendig' : 'Noch offen');
        }
      }

      return /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          height: '100%',
          width: '100%',
          backgroundColor: _cssConstants["default"].tiles && _cssConstants["default"].tiles.fullBackgroundColor ? _cssConstants["default"].tiles.fullBackgroundColor : 'white'
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        id: "".concat(FRONT_ID).concat(this.props.fadeOut ? '_fadeOut_' : '').concat(this.props.id),
        className: this.getClassNames(),
        style: style === null || style === void 0 ? void 0 : style.front
      }, this.props.showNewBanner ? /*#__PURE__*/_react["default"].createElement("div", {
        className: _ErvFront["default"].newBanner
      }, "Neu") : null, /*#__PURE__*/_react["default"].createElement("div", {
        className: "".concat(_ErvFront["default"].frontContainer).concat(extraClassName),
        style: style === null || style === void 0 ? void 0 : style.container
      }, this.renderBackground(style), _config["default"].renderProgressBarOnTile ? /*#__PURE__*/_react["default"].createElement("div", {
        style: style === null || style === void 0 ? void 0 : style.progressBar
      }, /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          position: 'absolute',
          zIndex: 4,
          left: 10,
          top: 2,
          width: '100%',
          height: '28px'
        }
      }, percentageInfo), /*#__PURE__*/_react["default"].createElement("div", {
        className: 'doNotInvert',
        style: (0, _assign["default"])(style.progressBarInner, {
          width: percentage === 100 ? "calc((100% * ".concat(percentage / 100, ") + 20px)") : "calc((100% * ".concat(percentage / 100, ") + 5px)")
        })
      })) : null, _config["default"].showDayInfoOnTile && currentDayStr ? /*#__PURE__*/_react["default"].createElement("div", {
        className: _ErvFront["default"].dayContainer,
        style: style === null || style === void 0 ? void 0 : style.dayInfo
      }, currentDayStr) : null, !(_config["default"].useBackgroundImageTitle && this.hasBackgroundImage()) && /*#__PURE__*/_react["default"].createElement("div", {
        className: _ErvFront["default"].title,
        style: content.fontColor ? (0, _assign["default"])(style.title ? style.title : {}, {
          color: content.fontColor
        }) : style.title
      }, title, _config["default"].addSubtitleToTitleField ? /*#__PURE__*/_react["default"].createElement("div", {
        className: _ErvFront["default"].subtitle,
        style: style === null || style === void 0 ? void 0 : style.subtitle
      }, this.props.subtitle) : null), _config["default"].showSubtitleOnTile && !_config["default"].addSubtitleToTitleField ? /*#__PURE__*/_react["default"].createElement("div", {
        className: _ErvFront["default"].subtitle,
        style: style === null || style === void 0 ? void 0 : style.subtitle
      }, subtitle) : null, this.renderIcon(style), _config["default"].showFav || _config["default"].showRead ? /*#__PURE__*/_react["default"].createElement("div", {
        className: _ErvFront["default"].containerRight,
        style: containerRightStyle
      }, _config["default"].showFav && this.props.type !== 'spoc' && this.props.type !== 'course' && /*#__PURE__*/_react["default"].createElement("div", {
        className: _ErvFront["default"].favIcon,
        onClick: /*#__PURE__*/function () {
          var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(e) {
            return _regenerator["default"].wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    e.stopPropagation();
                    _context2.next = 3;
                    return _KESI2Helper["default"].setFavoriteForLectureId(_this3.props.id, !fav);

                  case 3:
                    if (useOnlyAsLink) {
                      _this3.props.updateFavFunc();
                    }

                  case 4:
                  case "end":
                    return _context2.stop();
                }
              }
            }, _callee2);
          }));

          return function (_x) {
            return _ref2.apply(this, arguments);
          };
        }()
      }, fav ? /*#__PURE__*/_react["default"].createElement(_Image["default"], {
        alt: 'Favoritenicon',
        style: this.isInternetExplorer ? {
          height: "".concat(24 * this.props.zoomValue, "px")
        } : {
          height: '24px'
        },
        src: _config["default"].bookmarkIconTrueTile
      }) : /*#__PURE__*/_react["default"].createElement(_Image["default"], {
        alt: 'Favoritenicon',
        style: this.isInternetExplorer ? {
          height: "".concat(24 * this.props.zoomValue, "px")
        } : {
          height: '24px'
        },
        src: _config["default"].bookmarkIconFalseTile
      })), _config["default"].showRead && !useOnlyAsLink && /*#__PURE__*/_react["default"].createElement("div", {
        className: _ErvFront["default"].readIcon
      }, _KESI2Helper["default"].checkIfOnlyNotMandatoryNuggets(this.props.id) || read ? /*#__PURE__*/_react["default"].createElement(_reactFontawesome["default"], {
        style: {
          verticalAlign: 'top'
        },
        name: "check-circle"
      }) : /*#__PURE__*/_react["default"].createElement(_reactFontawesome["default"], {
        style: {
          verticalAlign: 'top'
        },
        name: "circle-o"
      }))) : null, this.props.processTime ? /*#__PURE__*/_react["default"].createElement("div", {
        className: _ErvFront["default"].containerLeft,
        style: _config["default"].useBackgroundImageTitle && this.hasBackgroundImage() ? (0, _assign["default"])({
          color: this.props.backgroundColor
        }, (style === null || style === void 0 ? void 0 : style.containerLeft) || {}) : (0, _assign["default"])({
          color: _cssConstants["default"].colors.tileFontColor
        }, (style === null || style === void 0 ? void 0 : style.containerLeft) || {})
      }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome["default"], {
        name: "clock-o"
      }), /*#__PURE__*/_react["default"].createElement("b", null, "\xA0\xA0", this.props.processTime, "\xA0min")) : null, _config["default"].showArrowOnTile ? /*#__PURE__*/_react["default"].createElement("div", {
        className: _ErvFront["default"].tileArrow,
        style: style === null || style === void 0 ? void 0 : style.arrow
      }, /*#__PURE__*/_react["default"].createElement(_Image["default"], {
        alt: "arrow right icon",
        style: this.isInternetExplorer ? {
          height: "".concat((style === null || style === void 0 ? void 0 : (_style$innerArrow = style.innerArrow) === null || _style$innerArrow === void 0 ? void 0 : _style$innerArrow.height) * this.props.zoomValue, "px"),
          width: "".concat((style === null || style === void 0 ? void 0 : (_style$innerArrow2 = style.innerArrow) === null || _style$innerArrow2 === void 0 ? void 0 : _style$innerArrow2.width) * this.props.zoomValue, "px")
        } : {
          height: "".concat(style === null || style === void 0 ? void 0 : (_style$innerArrow3 = style.innerArrow) === null || _style$innerArrow3 === void 0 ? void 0 : _style$innerArrow3.height, "px"),
          width: "".concat(style === null || style === void 0 ? void 0 : (_style$innerArrow4 = style.innerArrow) === null || _style$innerArrow4 === void 0 ? void 0 : _style$innerArrow4.width, "px")
        },
        src: _config["default"].arrowRight
      })) : null, this.props.isBooked ? /*#__PURE__*/_react["default"].createElement("div", {
        className: _ErvFront["default"].bookedMarker
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _ErvFront["default"].bookedText
      }, "Gebucht")) : null)), !useOnlyAsLink && /*#__PURE__*/_react["default"].createElement("div", {
        className: "".concat(_config["default"].openTilesInFullScreen ? _ErvFront["default"].lectureContainerNoBottomBar : _ErvFront["default"].lectureContainer, " ctnLectureContent"),
        style: content.innerBackgroundColor ? {
          backgroundColor: content.innerBackgroundColor
        } : {
          backgroundColor: 'white'
        }
      }, renderAnotherLayer && this.props.willBeOpened ? (_config["default"].useSimpleTileAnimation ? this.props.expanded : this.props.willBeOpened) ? /*#__PURE__*/_react["default"].createElement(_DrupalNestedNonFlippingTiles["default"], {
        setTitle: this.props.setTitle,
        setCount: this.props.setCount,
        setScrollBarHidden: this.props.setScrollBarHidden,
        setBackButtonFunc: this.props.setBackButtonFunc,
        contentPathArray: this.props.contentPathArray,
        setShowFavButton: this.props.setShowFavButton,
        showSettingsDialog: this.props.showSettingsDialog,
        isFirstLayer: false,
        outerCloseTile: this.props.outerCloseTile,
        outerDomId: this.props.outerDomId,
        closeTile: this.props.closeTile,
        domId: this.props.domId
      }) : null : (_config["default"].useSimpleTileAnimation ? this.props.expanded : this.props.willBeOpened) ? /*#__PURE__*/_react["default"].createElement(_DrupalLecture["default"], {
        showContent: this.props.expanded,
        params: {
          contentId: this.props.id
        },
        doNotSetHeight: this.props.doNotSetHeight,
        colorClasses: this.props.colorClasses,
        contentPathArray: this.props.contentPathArray,
        setShowFavButton: null,
        regionCode: this.props.regionCode,
        setBackButtonFunc: this.props.setBackButtonFunc,
        closeTile: this.closeTile,
        setTitle: this.props.setTitle,
        expanded: this.props.expanded,
        scrollFrameId: this.props.scrollFrameId,
        goUpFunc: this.closeTile,
        currentDayStr: currentDayStr,
        innerBackgroundColor: content.innerBackgroundColor,
        backgroundColor: this.getLectureColor(),
        goHomeFn: function goHomeFn() {
          return _this3.props.closeTile(_this3.props.domId);
        },
        setWizardArrowFns: this.props.setWizardArrowFns,
        resetScrollIndicatorFn: this.props.resetScrollIndicatorFn
      }) : null));
    }
  }]);
  return ErvFront;
}(_KESI2BasicComponent["default"]);

ErvFront.propTypes = {
  id: _propTypes["default"].string.isRequired,
  keywords: _propTypes["default"].string,
  arrowColor: _propTypes["default"].string,
  fontColor: _propTypes["default"].string,
  backgroundColor: _propTypes["default"].string,
  subtype: _propTypes["default"].string,
  icon: _propTypes["default"].string,
  svgIcon: _propTypes["default"].string,
  newSvgIcon: _propTypes["default"].string,
  background: _propTypes["default"].string,
  title: _propTypes["default"].string.isRequired,
  subtitle: _propTypes["default"].string,
  colorClasses: _propTypes["default"].shape({
    backgroundClass: _propTypes["default"].string,
    glowClass: _propTypes["default"].string
  }),
  size: _propTypes["default"].number.isRequired,
  correctedSize: _propTypes["default"].number,
  type: _propTypes["default"].string,
  processTime: _propTypes["default"].number,
  domId: _propTypes["default"].string,
  expanded: _propTypes["default"].bool,
  animated: _propTypes["default"].bool,
  willBeOpened: _propTypes["default"].bool,
  closeTile: _propTypes["default"].func,
  setBackButtonFunc: _propTypes["default"].func.isRequired,
  setTitle: _propTypes["default"].func,
  regionCode: _propTypes["default"].string,
  currentRegionCache: _propTypes["default"].object,
  regionUnavailable: _propTypes["default"].bool,
  tileContentDidMount: _propTypes["default"].func,
  fadeOut: _propTypes["default"].bool,
  greyedOut: _propTypes["default"].bool,
  setCount: _propTypes["default"].func,
  setScrollBarHidden: _propTypes["default"].func,
  setShowFavButton: _propTypes["default"].func,
  isOnFirstLayer: _propTypes["default"].bool,
  outerCloseTile: _propTypes["default"].func,
  outerDomId: _propTypes["default"].string,
  useAsLink: _propTypes["default"].bool,
  updateFavFunc: _propTypes["default"].func,
  scrollFrameId: _propTypes["default"].string,
  isPublished: _propTypes["default"].bool,
  isBooked: _propTypes["default"].bool,
  zoomValue: _propTypes["default"].number.isRequired,
  wasOpenedAutomatically: _propTypes["default"].bool,
  isShrinked: _propTypes["default"].bool,
  currentDay: _propTypes["default"].number,
  setWizardArrowFns: _propTypes["default"].func,
  resetScrollIndicatorFn: _propTypes["default"].func,
  showNewBanner: _propTypes["default"].bool
};
ErvFront.defaultProps = {
  animated: false,
  expanded: false,
  regionUnavailable: false,
  useAsLink: false,
  isBooked: false,
  isShrinked: false
};
var _default = ErvFront;
exports["default"] = _default;